import React, { useState } from 'react';
import { ArrowRightIcon, CheckCircleIcon, LockClosedIcon, PhoneIcon, SupportIcon, XCircleIcon } from '@heroicons/react/outline';
import { IMaskInput } from 'react-imask';
import axios from 'axios';
import { trackEvent } from '../facebookPixel';

function LandingPageOne(props) {

    const [loadingButton, setLoadingButton] = useState(false)
    const [successMessage, setSuccessMessage] = useState(false)



    const validEmail = new RegExp(
        '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$'
    );


    const errorObj = {
        firstName: false,
        lastName: false,
        email: false,
        cellPhone: false,
    }

    const [errors, setErrors] = useState({ ...errorObj })

    const validFormFields = () => {
        let updateErrorObj = { ...errors };
        Object.entries(props.form).some(([key, value]) => {
            if (key === "email") {
                if (!validEmail.test(value) || !value || value.length === 0) {
                    updateErrorObj[key] = true
                } else {
                    updateErrorObj[key] = false
                }
            } else if (key === 'cellPhone') {
                if (!value || value.replace("-", '').length !== 11) {
                    updateErrorObj[key] = true
                } else {
                    updateErrorObj[key] = false
                }

            } else if (key === 'totalDebt') {
                updateErrorObj[key] = false
            } else if (!value) {
                updateErrorObj[key] = true;
                console.log("field error", key, value)
            } else {
                updateErrorObj[key] = false
            }
            return null
        })

        setErrors(updateErrorObj)
        console.log("errors", errors)
        return (Object.values(updateErrorObj).includes(true)) ? false : true

    }
    //     <script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/embed/v2.js"></script>
    // <script>
    //   hbspt.forms.create({
    //     portalId: "47687577",
    //     formId: "aac420d5-98e3-4be1-b91a-ce7a6c3f51bf",
    //     region: "na1"
    //   });
    // </script>

    const submitForm = async (e) => {
        e.preventDefault();
        if (validFormFields()) {
            const payload =
            {
                "email": props.form.email,
                "firstname": props.form.firstName,
                "lastname": props.form.lastName,
                "phone": props.form.cellPhone,
                "how_much_do_you_estimate_you_owe_in_back_taxes_": props.form.totalDebt,
                "i_affirm_that_i_ve_reviewed_and_accepted_ovation_tax_group_sterms_and_conditionsandprivacy_policy_": true,
                "by_checking_this_box__i_agree_to_receive_communications__including_email__calls_and_text_messages_f": true,
            }


            try {
                const portalId = "47687577";
                const formGuid = "aac420d5-98e3-4be1-b91a-ce7a6c3f51bf";
                const endpoint = `https://forms.hubspot.com/uploads/form/v2/${portalId}/${formGuid}`;

                const response = await axios.post(endpoint, payload,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );

                console.log("Lead submitted successfully:", response.data);
                // console.log(endpoint, payload)
                setSuccessMessage(true)
                setLoadingButton(false)
                // Fire Facebook lead event
                trackEvent('Lead', {
                    content_name: 'Signup Form',
                });

            }
            catch (error) {
                console.error('error', error);
            } finally {
                setLoadingButton(false);
            }
        } else {
            console.log("Please fix form errors")
            setSuccessMessage(false)
        }
    }

    return (
        <div>

            {/* Hero Section */}
            <div className='block md:hidden bg-gradient-to-br from-gray-100 to-sky-50 text-center px-2 py-4'>
                {/* <h3 className="text-white text-lg font-bold mb-1">Want help now? Call us directly!</h3> */}
                <a className="font-bold flex items-center justify-center text-gray-900 text-xl hover:underline" href="tel:8884092328">
                    <PhoneIcon className='mr-2 h-5 w-5' /> (888)409-2328</a>
            </div>
            <header className="bg-sky-300 banner text-gray-900 px-4 pt-0 pb-10">

                <div className="py-20 text-center max-w-3xl mx-auto">
                    <h1 className="text-gray-900 text-5xl md:text-7xl font-bold">Overcome <br />Tax Debt with <br /><span className='font-serif text-sky-800 font-extrabold uppercase'>Expert</span> Help</h1>
                    <h2 className="mt-3 text-gray-800 text-2xl md:text-4xl font-bold">Here to connect you with Trusted Experts</h2>
                    <p className="mt-4 text-xl text-gray-900 font-serif">Connect with a qualified tax debt specialist who can help you resolve tax issues and take control of your financial future.</p>

                    <a href="#start" className="bg-sky-800 hover:bg-sky-600 text-white w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-6 inline-block">Get Your Free Consultation</a>

                </div>
            </header>

            {/* Main Content */}
            <main>
                <section>
                    <div className='bg-sky-100 text-center mb-10'>
                        <div className="max-w-2xl mx-auto p-4 md:p-10">
                            <div className='flex items-center justify-center mb-3'>
                                <SupportIcon className='h-20 w-20 text-sky-600' />
                            </div>
                            <h2 className="text-gray-800 text-3xl font-bold mb-8">Getting Tax Debt Help Is Easier Than You Think</h2>
                            <p className='text-left font-serif'>We know that taking the first step can be the hardest. That’s why we’ve made it simple and <b className="text-black font-serif">stress-free</b> to connect with one of our experts.</p>
                            <ul className="my-5 px-4 md:px-10 text-left max-w-xl mx-auto list-decimal">
                                <li><b className="text-black font-serif">Fill Out the Form –</b> It only takes a few moments to provide your basic information.</li>
                                <li><b className="text-black font-serif">Free Consultation Call –</b> Our tax debt expert will contact you to discuss your situation in confidence.</li>
                                <li><b className="text-black font-serif">Personalized Relief Plan –</b> Based on your specific circumstances, we’ll create an action plan to resolve your tax debt.</li>
                            </ul>

                            <div className='flex items-center justify-center gap-6'>


                                <a href="#start" className="hover:bg-sky-800 bg-sky-600 text-white border-2 hover:border-sky-800 border-sky-600 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-6 inline-block">Get Started</a>


                            </div>

                        </div>

                    </div>
                    <div className='my-10 text-center'>
                        <p className='text-gray-800 mb-3 text-lg font-semibold'>Prefer to speak with someone right away?</p>
                        <a className="flex items-center justify-center font-bold text-2xl font-serif hover:underline" href="tel:8884092328"> <PhoneIcon className='mr-2 h-6 w-6' /> (888)409-2328</a>
                    </div>
                </section>

                {/* Section 3: How It Works – Simple 3-Step Process */}
                <section className='mt-10 mb-20'>
                    <div className='md:rotate-3'>
                        <div className="max-w-3xl mx-auto">
                            <div className='grid grid-cols-1 md:grid-cols-3 gap-3'>
                                <div className='flex flex-col items-center shadow text-sky-800 bg-yellow-100 justify-center h-60 w-60  mx-auto md:h-64 md:w-full px-4 py-10'>
                                    <div className='bg-transparent text-3xl flex items-center border-dashed justify-center text-sky-800 border-sky-800 border-4 rounded-full font-bold h-14 w-14'>
                                        1
                                    </div>
                                    <h3 className='mt-2 text-gray-800 font-semibold text-2xl'>Submit Form</h3>
                                </div>
                                <div className='rotate-2 flex flex-col items-center shadow text-sky-800 bg-yellow-100 justify-center h-60 w-60  mx-auto md:h-64 md:w-full px-4 py-10'>
                                    <div className='bg-transparent text-3xl flex items-center border-dashed justify-center text-sky-800 border-sky-800 border-4 rounded-full font-bold h-14 w-14'>
                                        2
                                    </div>
                                    <h3 className='mt-2 text-gray-800 font-semibold text-2xl'>Free Call</h3>
                                </div>
                                <div className='-rotate-12 flex flex-col items-center shadow text-green-600 bg-yellow-100 justify-center h-60 w-60  mx-auto md:h-64 md:w-full px-4 py-10'>
                                    <div className='text-3xl flex items-center  justify-center text-white bg-green-600 border-green-600 border-4 rounded-full p-5 font-bold h-14 w-14'>
                                        3
                                    </div>
                                    <h3 className='mt-2 text-gray-800 text-center font-extrabold text-3xl font-serif'>Relief Plan <p className='text-sm font-bold uppercase'>Assistance</p></h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Section 1: Pain Points & Challenges */}
                <section className="bg-slate-50 grid grid-cols-1 lg:grid-cols-2">
                    <div className='order-2 md:order-1 relative flex justify-center items-center h-72 md:h-full md:w-full bg-gray-200'>
                        <img
                            src="/2.png"
                            alt="paper tax documents"
                            layout="fill"
                            className={`w-full h-full object-center object-cover`}
                        />
                    </div>
                    <div className='order-1 md:order-2 p-4 md:p-20'>

                        <h2 className="text-gray-800 text-3xl font-bold mb-8">Are You Feeling Overwhelmed by Tax Debt? <span className="font-serif text-sky-600">You’re Not Alone.</span></h2>
                        <p>Every year, thousands of individuals and businesses struggle with tax debt issues. Whether it’s from unexpected penalties, unfiled taxes, or mounting interest fees, the IRS has methods to collect. <b className="text-black font-serif">But you have options.</b> Our team of dedicated tax debt experts can help you understand these options, <b className="text-black font-serif">negotiate with the IRS</b>, and work toward a more manageable solution. Don’t face this alone—let us support you in finding relief.</p>
                        <a href="#start" className="justify-center text-gray-800 font-bold text-xl mt-5 flex items-center hover:text-sky-900">Get Tax Debt Help Today <ArrowRightIcon className='ml-2 h-4 w-4' /></a>
                    </div>

                </section>

                {/* Section 2: Solution Overview – How We Can Help */}
                <section className="bg-slate-50 grid grid-cols-1 lg:grid-cols-2">
                    <div className="px-4 py-10 md:p-20">
                        <h2 className="text-gray-800 text-3xl font-bold mb-8">Your <span className='text-sky-600 font-serif'>Trusted Partner</span> in Tax Debt Resolution</h2>
                        <p>When you’re in tax debt, it can feel like there’s no way out. A qualified tax debt specialist can make a world of difference, helping you reduce penalties, negotiate payment terms, and even <b className="text-black font-serif">reduce the amount you owe</b>. Our team has helped clients just like you reach resolutions and regain peace of mind. Here’s what we can help with:</p>
                        <ul className='list-disc ml-10'>
                            <li><b className='text-black font-serif'>Penalty Reductions:</b> Negotiating to minimize or eliminate penalties.</li>
                            <li><b className='text-black font-serif'>Settlement Options:</b> Exploring programs like the IRS Offer in Compromise to settle your debt for less.</li>
                            <li><b className='text-black font-serif'>Installment Plans:</b> Setting up manageable monthly payments based on your financial situation.</li>
                            <li><b className='text-black font-serif'>Tax Liens and Levy Releases:</b> Working to remove liens on your assets or release wage garnishments.</li>
                        </ul>
                        <a href="#start" className="justify-center text-gray-800 font-bold text-xl mt-5 flex items-center hover:text-sky-900">Take the First Step Toward Relief <ArrowRightIcon className='ml-2 h-4 w-4' /></a>
                    </div>
                    <div className='relative flex justify-center items-center h-72 md:h-full md:w-full bg-gray-200'>
                        <img
                            src="/3.png"
                            alt="a smiling couple shaking hands with a professional"
                            layout="fill"
                            className={`w-full h-full object-center object-cover`}
                        />
                    </div>
                </section>



                {/* Section 4: Testimonials and Social Proof */}
                {/* <section className="bg-gray-200 py-10">
                    <div className=" text-center">
                        <h2 className="text-sky-500 text-3xl font-bold mb-8">See How We’ve Helped People Just Like You</h2>
                        <p>We know that taking the first step can be the hardest. That’s why we’ve made it simple and <b className="text-black font-serif">stress-free</b> to connect with one of our experts.</p>
                        <p>“Before working with [Your Company Name], I was facing wage garnishment and mounting penalties. Their team not only reduced my debt but helped me set up a payment plan that I could afford. Now I’m back on track!”
                            – John D., Dallas, TX</p>
                        <p>“I was overwhelmed with tax debt and didn’t know where to start. [Your Company Name] guided me every step of the way, and I finally feel at ease with my finances.”
                            – Sarah P., Los Angeles, CA</p>




                    </div>
                </section> */}

                {/* Section 5: Final CTA and Form */}
                <section>
                    <div className='bg-sky-800 text-center'>
                        <div className="max-w-4xl mx-auto px-4 py-10 md:p-10">
                            <div className='flex items-center justify-center mb-3'>
                                <LockClosedIcon className='text-white h-20 w-20' />
                            </div>
                            <h2 className="font-serif text-white text-4xl md:text-5xl font-bold mb-1">
                                Take Control of Your Financial Future</h2>

                            <p className='text-white text-xl max-w-4xl mx-auto mt-10 mb-2 font-serif'>Ready to start your journey to financial relief? Fill out the form below to connect with a qualified tax debt specialist for a free consultation.</p>
                            <a href="#start" className="hover:bg-white bg-sky-800 text-white border-2  hover:border-sky-800 border-white hover:text-gray-900 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-6 inline-block">Get Started</a>

                        </div>
                    </div>
                    <div className='bg-sky-900 text-center px-4 py-10 md:p-10'>
                        <h3 className="text-white text-xl font-bold mb-1">Talk to an Expert Today</h3>
                        <a className="font-bold  text-white text-3xl hover:underline" href="tel:8884092328">(888)409-2328</a>
                    </div>
                </section>

                <section id="start">
                    <div className="grid grid-cols-1 lg:grid-cols-2">
                        <div className='order-2 md:order-1 relative flex justify-center items-center h-72 md:h-full md:w-full bg-gray-200'>
                            <img
                                src="/14.png"
                                alt="older couple smiling looking at laptop on couch"
                                layout="fill"
                                className={`w-full h-full object-center object-cover`}
                            />
                        </div>
                        <form className="bg-slate-50 order-1 md:order-2 px-4 py-10 md:p-20">
                            {!successMessage ?
                                <div className='max-w-2xl mx-auto'>
                                    <h2 className='font-bold text-4xl mb-6 text-center md:text-left'>Connect with an Expert Today</h2>
                                    <div className=" text-left grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
                                        <div className="sm:col-span-3">
                                            <label htmlFor="first-name" className="block text-sm/6 font-medium text-gray-900">
                                                First Name
                                            </label>
                                            <div className="my-2">
                                                <input
                                                    onChange={(event) => props.updateFieldValue("firstName", event.target.value)}

                                                    id="first-name"
                                                    name="first-name"
                                                    type="text"
                                                    autoComplete="given-name"
                                                    className={`px-3 h-12 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-800 sm:text-sm/6 ${errors.firstName ? 'bg-red-100' : 'bg-white'}`}
                                                />
                                                {errors.firstName && <p className="absolute flex items-center text-sm text-red-600"><XCircleIcon className='mt-1 mr-1 h-4 w-4 text-red-500' /> The name field is required.</p>}
                                            </div>
                                        </div>

                                        <div className="sm:col-span-3">
                                            <label htmlFor="last-name" className="block text-sm/6 font-medium text-gray-900">
                                                Last Name
                                            </label>
                                            <div className="my-2">
                                                <input
                                                    onChange={(event) => props.updateFieldValue("lastName", event.target.value)}

                                                    id="last-name"
                                                    name="last-name"
                                                    type="text"
                                                    autoComplete="family-name"
                                                    className={`px-3 h-12 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-800 sm:text-sm/6 ${errors.lastName ? 'bg-red-100' : 'bg-white'}`}
                                                />
                                                {errors.lastName && <p className="absolute flex items-center text-sm text-red-600"><XCircleIcon className='mt-1 mr-1 h-4 w-4 text-red-500' /> The name field is required.</p>}
                                            </div>
                                        </div>

                                        <div className="col-span-full">
                                            <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                                Email Address
                                            </label>
                                            <div className="my-2">
                                                <input
                                                    onChange={(event) => props.updateFieldValue("email", event.target.value)}

                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    autoComplete="email"
                                                    className={`px-3 h-12 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-800 sm:text-sm/6 ${errors.email ? 'bg-red-100' : 'bg-white'}`}
                                                />
                                                {errors.email && <p className="absolute flex items-center text-sm text-red-600"><XCircleIcon className='mt-1 mr-1 h-4 w-4 text-red-500' /> The email field must be a valid email address.</p>}
                                            </div>
                                        </div>

                                        <div className="sm:col-span-3">
                                            <label htmlFor="phone" className="block text-sm/6 font-medium text-gray-900">
                                                Phone
                                            </label>
                                            <div className="my-2">
                                                {/* <input
                                                onChange={(event) => setForm("phone", event.target.value)}
                                                id="phone"
                                                name="phone"
                                                type="text"
                                                autoComplete="phone-number"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-800 sm:text-sm/6"
                                            /> */}
                                                <IMaskInput
                                                    onChange={(event) => props.updateFieldValue("cellPhone", event.target.value)}

                                                    mask="000-000-0000"
                                                    className={`px-3 h-12 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-800 sm:text-sm/6 ${errors.cellPhone ? 'bg-red-100' : 'bg-white'}`}
                                                />
                                                {errors.cellPhone && <p className="absolute flex items-center text-sm text-red-600"><XCircleIcon className='mt-1 mr-1 h-4 w-4 text-red-500' /> The phone field must be a valid U.S. phone number.</p>}
                                            </div>
                                        </div>


                                        <div className="sm:col-span-3">
                                            <label htmlFor="debt" className="block text-sm/6 font-medium text-gray-900">
                                                Debt Amount Estimate
                                            </label>
                                            <div className="mt-2">
                                                <select
                                                    onChange={(event) => props.updateFieldValue("totalDebt", event.target.value)}
                                                    id="debt"
                                                    name="debt"
                                                    autoComplete="debt-amount"
                                                    className="px-3 h-12 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-800 sm:text-sm/6"
                                                >
                                                    <option>$1 - $4,999</option>
                                                    <option>$5,000 - $9,999</option>
                                                    <option>$10,000 - $29,999</option>
                                                    <option>$30,000 - $49,999</option>
                                                    <option>$50,000 or more</option>
                                                </select>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="mt-8">

                                        <button
                                            onClick={(e) => submitForm(e)}
                                            type="submit"
                                            disabled={loadingButton ? true : false}
                                            className={`${loadingButton ? "bg-gray-400 text-gray-600" : "bg-sky-800 hover:bg-sky-600 text-white"} w-full text-center py-4 px-8 text-xl flex items-center justify-center rounded-md shadow font-semibold h-14 mt-6`}>
                                            Submit <ArrowRightIcon className='ml-2 h-4 w-4' />
                                        </button>
                                        <p className='text-gray-500 text-xs mt-5'>
                                            By clicking submit, I give Ovation Tax Group LLC and any of our partners, affiliates, agents, assigns, and service providers express written permission to contact me at the number and email provided above, via email, phone, text message (SMS/MMS), and/or cell phone, including the use of automated dialing equipment, artificial intelligence, and pre-recorded calls and/or messages for informational or promotional purposes. Message and data rates may apply. Message frequency varies.You further agree that Ovation Tax Group LLC may send emails to you at any email address you provide us or use other electronic means of communication to the extent permitted by law. Consent can be revoked at any time by replying STOP to any text message. Your consent to these terms is not a condition of purchase. For more information, please review our Privacy Policy.
                                        </p>
                                    </div>
                                </div>
                                :
                                <div className='text-gray-600 text-center h-80 flex items-center justify-center'>
                                    <div>
                                        <CheckCircleIcon className='mx-auto text-green-700 h-10 w-10' />
                                        <h4 className='font-bold text-2xl text-green-800'>Form submission successful.</h4>
                                        A representative will reach out shortly to confirm your qualification.
                                    </div>
                                </div>
                            }
                        </form>
                    </div>
                </section>
            </main>
        </div>
    );
}

export default LandingPageOne;
